import { apiClient } from "./apiClient";
import type { ApiResponse, CurrentUser } from "./types";

function decodeJwtUser(token: string): CurrentUser {
  const payload = JSON.parse(atob(token.split(".")[1] ?? ""));
  const roleClaim = payload["role"] ?? payload["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] ?? [];
  const roles = Array.isArray(roleClaim) ? roleClaim : [roleClaim].filter(Boolean);
  const permissions = Object.keys(payload)
    .filter((key) => key.toLowerCase().includes("permission"))
    .flatMap((key) => Array.isArray(payload[key]) ? payload[key] : [payload[key]])
    .filter(Boolean);
  return {
    id: String(payload.nameid ?? payload.sub ?? payload.userId ?? ""),
    email: String(payload.email ?? payload.unique_name ?? ""),
    displayName: String(payload.given_name ?? payload.name ?? payload.email ?? "User"),
    roles,
    permissions
  };
}

export async function login(email: string, password: string) {
  const { data } = await apiClient.post<ApiResponse<{ accessToken: string; refreshToken: string; email?: string; userId?: string }>>(
    "/auth/login",
    { email, password }
  );
  const payload = data.data;
  if (!payload?.accessToken) throw new Error(data.message || "Login failed");
  return {
    accessToken: payload.accessToken,
    refreshToken: payload.refreshToken,
    user: decodeJwtUser(payload.accessToken)
  };
}

export async function register(payload: { email: string; password: string; confirmPassword?: string; firstName?: string; lastName?: string }) {
  const { data } = await apiClient.post<ApiResponse<unknown>>("/auth/register", payload);
  return data;
}

export async function forgotPassword(email: string) {
  const { data } = await apiClient.post<ApiResponse<unknown>>("/auth/forgot-password", { email });
  return data;
}
